import React from 'react'
import { Cell } from 'fixed-data-table';

import getConstructorType from '../../commonJS/getConstructorType';


export const SortTypes = {
  ASC: 'ASC',
  DESC: 'DESC'
};

export class DataListWrapper {
  constructor(indexMap, orinData, idKey) {
    this._indexMap = indexMap;
    this._data = orinData;

    // generating idsToMap
    // 有給idKey代表要生成idsToMap陣列
    if (idKey !== undefined && idKey !== '') {

      const type = getConstructorType(idKey);
      let idsToMap;

      // idKey為字串則以該字串為id屬性名稱跑迴圈取值產生idsToMap
      if(type === 'string') {
        idsToMap = [];
        for (let i = 0, len = indexMap.length; i < len; i++) {
          idsToMap[i] = orinData[indexMap[i]][idKey];
        }
      // idKey為陣列則直接帶入為idsToMap
      } else if(type === 'array') {
        idsToMap = idKey;
      } else {
        return;
      }

      this._idsToMap = idsToMap;
    }

  }



  getSize() {
    // _data只做為data base，indexMap則是實際上顯示的筆數以及排序依據
    // 所以刪除資料時並不需要從_data中移除，只需從indexMap中移除索引即可
    return this._indexMap.length;
  }

  getObjectAt(index) {
    return this._data[this._indexMap[index]];
  }

}

// 共用的單一物件 ===
export const emptyDataList = {
  emptyDataListWrapper: new DataListWrapper([], []),
  colSortDirs: {}
};
// ===

export function getDefaultTableDataObj (data) {
  const len = data.length;
  let indexMap = [];

  for(let i = 0; i < len; i++) {
    indexMap.push(i);
  }

  return new DataListWrapper(indexMap, data);
};

// rowIndex prop為column元件會自動傳入至其cell元件的props
export const TextCell = ({rowIndex, sortedData, columnKey, onClick, ...props}) => (
  <Cell {...props} onClick={ e => {if(onClick) onClick(e, rowIndex, sortedData);}}>
    {sortedData.getObjectAt(rowIndex)[columnKey]}
  </Cell>
);

export const TrueOrFalseCell = ({rowIndex, sortedData, columnKey, onClick, ...props}) => (
  <Cell {...props} onClick={ e => {if(onClick) onClick(e, rowIndex, sortedData);}}>
    {sortedData.getObjectAt(rowIndex)[columnKey] === '1' ? '是' : '否'}
  </Cell>
);

export const NewsTypeCell =  ({rowIndex, sortedData, columnKey, ...props}) => {
  const newsTypeName = function(rowIndex, sortedData, columnKey){
    if(sortedData.getObjectAt(rowIndex)[columnKey] === 'normal') return '一般';
    if(sortedData.getObjectAt(rowIndex)[columnKey] === 'pin') return '置頂';
    if(sortedData.getObjectAt(rowIndex)[columnKey] === 'star') return '重要';
  }
  return(
    <Cell {...props} >
      { newsTypeName(rowIndex, sortedData, columnKey) }
    </Cell>
)};

export const CustomerStreetCell = ({rowIndex, sortedData, columnKey, ...props}) => {
  const getStreetFromAddress = function(rowIndex, sortedData, columnKey){
    // return sortedData.getObjectAt(rowIndex)[columnKey].street;
    return sortedData.getObjectAt(rowIndex)[columnKey];
  }
  return (
  <Cell {...props} >
    { getStreetFromAddress(rowIndex, sortedData, columnKey) }
  </Cell>
)};

export const TimeWithoutHHmmssCell = ({rowIndex, sortedData, columnKey, ...props}) => {
  const getTimeWithoutHHmmss = function(rowIndex, sortedData, columnKey){
    let time = sortedData.getObjectAt(rowIndex)[columnKey];
    
    if(time!==null){//如果時間不等於null,只取日期的部分
      return time.substring(0,10)
    } else {
      return "";
    }
  }
  return (
  <Cell {...props} >
    { getTimeWithoutHHmmss(rowIndex, sortedData, columnKey) }
  </Cell>
)};

function reverseSortDirection(sortDir) {
  return sortDir === SortTypes.DESC ? SortTypes.ASC : SortTypes.DESC;
}

export class SortHeaderCell extends React.Component {
  constructor(props) {
    super(props);
    this.onSortChange = this.onSortChange.bind(this);
  }
  onSortChange(event){
    event.preventDefault();
    if (this.props.onSortChange) {
        this.props.onSortChange(
          this.props.columnKey,
          (this.props.sortDir ?
            reverseSortDirection(this.props.sortDir) :
            SortTypes.DESC),
          SortTypes
        );
    }
  }
  render() {
    const {sortDir, children, height, width, columnKey} = this.props;
    return (
      <Cell height={height} width={width} columnKey={columnKey}>
        <a onClick={this.onSortChange} 
          style={{textDecoration: "none", cursor: "pointer"}}>
          {children} {sortDir ? (sortDir === SortTypes.DESC ? '↓' : '↑') : ''}
        </a>
      </Cell>
    );
  }
}


function mapFilterWithId(indexMap, idsToMap, id) {
  const filteredIndexMap = [], filteredIdsToMap = [];

  for (let i = 0, len = idsToMap.length; i < len; i++) {
    if (idsToMap[i] === id) {
      filteredIndexMap.push(indexMap[i]);
      filteredIdsToMap.push(idsToMap[i]);
    }
  }


  return {
    filteredIndexMap,
    filteredIdsToMap
  }
}

export function dataListFilterWithId(dataListWrapper, id, noIdsToMap) {
  const indexMap = dataListWrapper._indexMap,
        idsToMap = dataListWrapper._idsToMap,
        filteredMap = mapFilterWithId(indexMap, idsToMap, id);


  return new DataListWrapper(filteredMap.filteredIndexMap, dataListWrapper._data, noIdsToMap ? "" : filteredMap.filteredIdsToMap);
}



// WEBPACK FOOTER //
// ./src/commonComponents/DataTable/DataTablePs.jsx